var _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect0, _rect1, _rect10, _rect11, _rect12, _rect13, _rect14, _rect15, _rect16, _rect17, _rect18, _rect19, _rect20, _rect21, _rect22, _rect23, _rect24, _rect25, _rect26, _rect27, _rect28, _rect29, _rect30, _rect31, _rect32, _rect33, _rect34, _rect35, _rect36, _rect37, _rect38, _rect39, _rect40, _rect41, _rect42, _rect43, _rect44, _rect45, _rect46, _rect47, _rect48, _rect49, _rect50, _rect51, _rect52, _rect53, _rect54, _rect55, _rect56, _rect57, _rect58, _rect59, _rect60, _rect61, _rect62, _rect63, _rect64, _rect65, _rect66, _rect67, _rect68, _rect69, _rect70, _rect71, _rect72, _rect73, _rect74, _rect75, _rect76, _rect77, _rect78, _rect79, _rect80, _rect81, _rect82, _rect83, _rect84, _rect85, _rect86, _rect87, _rect88, _rect89, _rect90, _rect91, _rect92, _rect93, _rect94, _rect95, _rect96, _rect97, _rect98, _rect99, _rect100, _rect101, _rect102, _rect103, _path, _path2, _rect104, _rect105, _path3, _rect106, _rect107, _path4, _rect108, _rect109, _path5, _rect110, _rect111, _path6, _path7, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPerformBatchLookup({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 334,
    height: 217,
    viewBox: "0 0 334 217",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 6.5,
    y: 8.70898,
    width: 23,
    height: 23,
    stroke: "#E1E4EA"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 29.5,
    y: 8.70898,
    width: 23,
    height: 23,
    stroke: "#E1E4EA"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 52.5,
    y: 8.70898,
    width: 23,
    height: 23,
    stroke: "#E1E4EA"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 75.5,
    y: 8.70898,
    width: 23,
    height: 23,
    stroke: "#E1E4EA"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 98.5,
    y: 8.70898,
    width: 23,
    height: 23,
    stroke: "#E1E4EA"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 121.5,
    y: 8.70898,
    width: 23,
    height: 23,
    stroke: "#E1E4EA"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 144.5,
    y: 8.70898,
    width: 23,
    height: 23,
    stroke: "#E1E4EA"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 167.5,
    y: 8.70898,
    width: 23,
    height: 23,
    stroke: "#E1E4EA"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 190.5,
    y: 8.70898,
    width: 23,
    height: 23,
    stroke: "#E1E4EA"
  })), _rect0 || (_rect0 = /*#__PURE__*/React.createElement("rect", {
    x: 213.5,
    y: 8.70898,
    width: 23,
    height: 23,
    stroke: "#E1E4EA"
  })), _rect1 || (_rect1 = /*#__PURE__*/React.createElement("rect", {
    x: 236.5,
    y: 8.70898,
    width: 23,
    height: 23,
    stroke: "#E1E4EA"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 259.5,
    y: 8.70898,
    width: 23,
    height: 23,
    stroke: "#E1E4EA"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 282.5,
    y: 8.70898,
    width: 23,
    height: 23,
    stroke: "#E1E4EA"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 305.5,
    y: 8.70898,
    width: 23,
    height: 23,
    stroke: "#E1E4EA"
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 6.5,
    y: 31.709,
    width: 23,
    height: 23,
    stroke: "#E1E4EA"
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    x: 29.5,
    y: 31.709,
    width: 23,
    height: 23,
    stroke: "#E1E4EA"
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    x: 52.5,
    y: 31.709,
    width: 23,
    height: 23,
    stroke: "#E1E4EA"
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    x: 75.5,
    y: 31.709,
    width: 23,
    height: 23,
    stroke: "#E1E4EA"
  })), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    x: 98.5,
    y: 31.709,
    width: 23,
    height: 23,
    stroke: "#E1E4EA"
  })), _rect18 || (_rect18 = /*#__PURE__*/React.createElement("rect", {
    x: 121.5,
    y: 31.709,
    width: 23,
    height: 23,
    stroke: "#E1E4EA"
  })), _rect19 || (_rect19 = /*#__PURE__*/React.createElement("rect", {
    x: 144.5,
    y: 31.709,
    width: 23,
    height: 23,
    stroke: "#E1E4EA"
  })), _rect20 || (_rect20 = /*#__PURE__*/React.createElement("rect", {
    x: 167.5,
    y: 31.709,
    width: 23,
    height: 23,
    stroke: "#E1E4EA"
  })), _rect21 || (_rect21 = /*#__PURE__*/React.createElement("rect", {
    x: 190.5,
    y: 31.709,
    width: 23,
    height: 23,
    stroke: "#E1E4EA"
  })), _rect22 || (_rect22 = /*#__PURE__*/React.createElement("rect", {
    x: 213.5,
    y: 31.709,
    width: 23,
    height: 23,
    stroke: "#E1E4EA"
  })), _rect23 || (_rect23 = /*#__PURE__*/React.createElement("rect", {
    x: 236.5,
    y: 31.709,
    width: 23,
    height: 23,
    stroke: "#E1E4EA"
  })), _rect24 || (_rect24 = /*#__PURE__*/React.createElement("rect", {
    x: 259.5,
    y: 31.709,
    width: 23,
    height: 23,
    stroke: "#E1E4EA"
  })), _rect25 || (_rect25 = /*#__PURE__*/React.createElement("rect", {
    x: 282.5,
    y: 31.709,
    width: 23,
    height: 23,
    stroke: "#E1E4EA"
  })), _rect26 || (_rect26 = /*#__PURE__*/React.createElement("rect", {
    x: 305.5,
    y: 31.709,
    width: 23,
    height: 23,
    stroke: "#E1E4EA"
  })), _rect27 || (_rect27 = /*#__PURE__*/React.createElement("rect", {
    x: 6.5,
    y: 54.709,
    width: 23,
    height: 23,
    stroke: "#E1E4EA"
  })), _rect28 || (_rect28 = /*#__PURE__*/React.createElement("rect", {
    x: 29.5,
    y: 54.709,
    width: 23,
    height: 23,
    stroke: "#E1E4EA"
  })), _rect29 || (_rect29 = /*#__PURE__*/React.createElement("rect", {
    x: 52.5,
    y: 54.709,
    width: 23,
    height: 23,
    stroke: "#E1E4EA"
  })), _rect30 || (_rect30 = /*#__PURE__*/React.createElement("rect", {
    x: 75.5,
    y: 54.709,
    width: 23,
    height: 23,
    stroke: "#E1E4EA"
  })), _rect31 || (_rect31 = /*#__PURE__*/React.createElement("rect", {
    x: 98.5,
    y: 54.709,
    width: 23,
    height: 23,
    stroke: "#E1E4EA"
  })), _rect32 || (_rect32 = /*#__PURE__*/React.createElement("rect", {
    x: 121.5,
    y: 54.709,
    width: 23,
    height: 23,
    stroke: "#E1E4EA"
  })), _rect33 || (_rect33 = /*#__PURE__*/React.createElement("rect", {
    x: 144.5,
    y: 54.709,
    width: 23,
    height: 23,
    stroke: "#E1E4EA"
  })), _rect34 || (_rect34 = /*#__PURE__*/React.createElement("rect", {
    x: 167.5,
    y: 54.709,
    width: 23,
    height: 23,
    stroke: "#E1E4EA"
  })), _rect35 || (_rect35 = /*#__PURE__*/React.createElement("rect", {
    x: 190.5,
    y: 54.709,
    width: 23,
    height: 23,
    stroke: "#E1E4EA"
  })), _rect36 || (_rect36 = /*#__PURE__*/React.createElement("rect", {
    x: 213.5,
    y: 54.709,
    width: 23,
    height: 23,
    stroke: "#E1E4EA"
  })), _rect37 || (_rect37 = /*#__PURE__*/React.createElement("rect", {
    x: 236.5,
    y: 54.709,
    width: 23,
    height: 23,
    stroke: "#E1E4EA"
  })), _rect38 || (_rect38 = /*#__PURE__*/React.createElement("rect", {
    x: 259.5,
    y: 54.709,
    width: 23,
    height: 23,
    stroke: "#E1E4EA"
  })), _rect39 || (_rect39 = /*#__PURE__*/React.createElement("rect", {
    x: 282.5,
    y: 54.709,
    width: 23,
    height: 23,
    stroke: "#E1E4EA"
  })), _rect40 || (_rect40 = /*#__PURE__*/React.createElement("rect", {
    x: 305.5,
    y: 54.709,
    width: 23,
    height: 23,
    stroke: "#E1E4EA"
  })), _rect41 || (_rect41 = /*#__PURE__*/React.createElement("rect", {
    x: 6.5,
    y: 77.709,
    width: 23,
    height: 23,
    stroke: "#E1E4EA"
  })), _rect42 || (_rect42 = /*#__PURE__*/React.createElement("rect", {
    x: 29.5,
    y: 77.709,
    width: 23,
    height: 23,
    stroke: "#E1E4EA"
  })), _rect43 || (_rect43 = /*#__PURE__*/React.createElement("rect", {
    x: 52.5,
    y: 77.709,
    width: 23,
    height: 23,
    stroke: "#E1E4EA"
  })), _rect44 || (_rect44 = /*#__PURE__*/React.createElement("rect", {
    x: 75.5,
    y: 77.709,
    width: 23,
    height: 23,
    stroke: "#E1E4EA"
  })), _rect45 || (_rect45 = /*#__PURE__*/React.createElement("rect", {
    x: 98.5,
    y: 77.709,
    width: 23,
    height: 23,
    stroke: "#E1E4EA"
  })), _rect46 || (_rect46 = /*#__PURE__*/React.createElement("rect", {
    x: 121.5,
    y: 77.709,
    width: 23,
    height: 23,
    stroke: "#E1E4EA"
  })), _rect47 || (_rect47 = /*#__PURE__*/React.createElement("rect", {
    x: 144.5,
    y: 77.709,
    width: 23,
    height: 23,
    stroke: "#E1E4EA"
  })), _rect48 || (_rect48 = /*#__PURE__*/React.createElement("rect", {
    x: 167.5,
    y: 77.709,
    width: 23,
    height: 23,
    stroke: "#E1E4EA"
  })), _rect49 || (_rect49 = /*#__PURE__*/React.createElement("rect", {
    x: 190.5,
    y: 77.709,
    width: 23,
    height: 23,
    stroke: "#E1E4EA"
  })), _rect50 || (_rect50 = /*#__PURE__*/React.createElement("rect", {
    x: 213.5,
    y: 77.709,
    width: 23,
    height: 23,
    stroke: "#E1E4EA"
  })), _rect51 || (_rect51 = /*#__PURE__*/React.createElement("rect", {
    x: 236.5,
    y: 77.709,
    width: 23,
    height: 23,
    stroke: "#E1E4EA"
  })), _rect52 || (_rect52 = /*#__PURE__*/React.createElement("rect", {
    x: 259.5,
    y: 77.709,
    width: 23,
    height: 23,
    stroke: "#E1E4EA"
  })), _rect53 || (_rect53 = /*#__PURE__*/React.createElement("rect", {
    x: 282.5,
    y: 77.709,
    width: 23,
    height: 23,
    stroke: "#E1E4EA"
  })), _rect54 || (_rect54 = /*#__PURE__*/React.createElement("rect", {
    x: 305.5,
    y: 77.709,
    width: 23,
    height: 23,
    stroke: "#E1E4EA"
  })), _rect55 || (_rect55 = /*#__PURE__*/React.createElement("rect", {
    x: 6.5,
    y: 100.709,
    width: 23,
    height: 23,
    stroke: "#E1E4EA"
  })), _rect56 || (_rect56 = /*#__PURE__*/React.createElement("rect", {
    x: 29.5,
    y: 100.709,
    width: 23,
    height: 23,
    stroke: "#E1E4EA"
  })), _rect57 || (_rect57 = /*#__PURE__*/React.createElement("rect", {
    x: 52.5,
    y: 100.709,
    width: 23,
    height: 23,
    stroke: "#E1E4EA"
  })), _rect58 || (_rect58 = /*#__PURE__*/React.createElement("rect", {
    x: 75.5,
    y: 100.709,
    width: 23,
    height: 23,
    stroke: "#E1E4EA"
  })), _rect59 || (_rect59 = /*#__PURE__*/React.createElement("rect", {
    x: 98.5,
    y: 100.709,
    width: 23,
    height: 23,
    stroke: "#E1E4EA"
  })), _rect60 || (_rect60 = /*#__PURE__*/React.createElement("rect", {
    x: 121.5,
    y: 100.709,
    width: 23,
    height: 23,
    stroke: "#E1E4EA"
  })), _rect61 || (_rect61 = /*#__PURE__*/React.createElement("rect", {
    x: 144.5,
    y: 100.709,
    width: 23,
    height: 23,
    stroke: "#E1E4EA"
  })), _rect62 || (_rect62 = /*#__PURE__*/React.createElement("rect", {
    x: 167.5,
    y: 100.709,
    width: 23,
    height: 23,
    stroke: "#E1E4EA"
  })), _rect63 || (_rect63 = /*#__PURE__*/React.createElement("rect", {
    x: 190.5,
    y: 100.709,
    width: 23,
    height: 23,
    stroke: "#E1E4EA"
  })), _rect64 || (_rect64 = /*#__PURE__*/React.createElement("rect", {
    x: 213.5,
    y: 100.709,
    width: 23,
    height: 23,
    stroke: "#E1E4EA"
  })), _rect65 || (_rect65 = /*#__PURE__*/React.createElement("rect", {
    x: 236.5,
    y: 100.709,
    width: 23,
    height: 23,
    stroke: "#E1E4EA"
  })), _rect66 || (_rect66 = /*#__PURE__*/React.createElement("rect", {
    x: 259.5,
    y: 100.709,
    width: 23,
    height: 23,
    stroke: "#E1E4EA"
  })), _rect67 || (_rect67 = /*#__PURE__*/React.createElement("rect", {
    x: 282.5,
    y: 100.709,
    width: 23,
    height: 23,
    stroke: "#E1E4EA"
  })), _rect68 || (_rect68 = /*#__PURE__*/React.createElement("rect", {
    x: 305.5,
    y: 100.709,
    width: 23,
    height: 23,
    stroke: "#E1E4EA"
  })), _rect69 || (_rect69 = /*#__PURE__*/React.createElement("rect", {
    x: 6.5,
    y: 123.709,
    width: 23,
    height: 23,
    stroke: "#E1E4EA"
  })), _rect70 || (_rect70 = /*#__PURE__*/React.createElement("rect", {
    x: 29.5,
    y: 123.709,
    width: 23,
    height: 23,
    stroke: "#E1E4EA"
  })), _rect71 || (_rect71 = /*#__PURE__*/React.createElement("rect", {
    x: 52.5,
    y: 123.709,
    width: 23,
    height: 23,
    stroke: "#E1E4EA"
  })), _rect72 || (_rect72 = /*#__PURE__*/React.createElement("rect", {
    x: 75.5,
    y: 123.709,
    width: 23,
    height: 23,
    stroke: "#E1E4EA"
  })), _rect73 || (_rect73 = /*#__PURE__*/React.createElement("rect", {
    x: 98.5,
    y: 123.709,
    width: 23,
    height: 23,
    stroke: "#E1E4EA"
  })), _rect74 || (_rect74 = /*#__PURE__*/React.createElement("rect", {
    x: 121.5,
    y: 123.709,
    width: 23,
    height: 23,
    stroke: "#E1E4EA"
  })), _rect75 || (_rect75 = /*#__PURE__*/React.createElement("rect", {
    x: 144.5,
    y: 123.709,
    width: 23,
    height: 23,
    stroke: "#E1E4EA"
  })), _rect76 || (_rect76 = /*#__PURE__*/React.createElement("rect", {
    x: 167.5,
    y: 123.709,
    width: 23,
    height: 23,
    stroke: "#E1E4EA"
  })), _rect77 || (_rect77 = /*#__PURE__*/React.createElement("rect", {
    x: 190.5,
    y: 123.709,
    width: 23,
    height: 23,
    stroke: "#E1E4EA"
  })), _rect78 || (_rect78 = /*#__PURE__*/React.createElement("rect", {
    x: 213.5,
    y: 123.709,
    width: 23,
    height: 23,
    stroke: "#E1E4EA"
  })), _rect79 || (_rect79 = /*#__PURE__*/React.createElement("rect", {
    x: 236.5,
    y: 123.709,
    width: 23,
    height: 23,
    stroke: "#E1E4EA"
  })), _rect80 || (_rect80 = /*#__PURE__*/React.createElement("rect", {
    x: 259.5,
    y: 123.709,
    width: 23,
    height: 23,
    stroke: "#E1E4EA"
  })), _rect81 || (_rect81 = /*#__PURE__*/React.createElement("rect", {
    x: 282.5,
    y: 123.709,
    width: 23,
    height: 23,
    stroke: "#E1E4EA"
  })), _rect82 || (_rect82 = /*#__PURE__*/React.createElement("rect", {
    x: 305.5,
    y: 123.709,
    width: 23,
    height: 23,
    stroke: "#E1E4EA"
  })), _rect83 || (_rect83 = /*#__PURE__*/React.createElement("rect", {
    x: 6.5,
    y: 146.709,
    width: 23,
    height: 23,
    stroke: "#E1E4EA"
  })), _rect84 || (_rect84 = /*#__PURE__*/React.createElement("rect", {
    x: 29.5,
    y: 146.709,
    width: 23,
    height: 23,
    stroke: "#E1E4EA"
  })), _rect85 || (_rect85 = /*#__PURE__*/React.createElement("rect", {
    x: 52.5,
    y: 146.709,
    width: 23,
    height: 23,
    stroke: "#E1E4EA"
  })), _rect86 || (_rect86 = /*#__PURE__*/React.createElement("rect", {
    x: 75.5,
    y: 146.709,
    width: 23,
    height: 23,
    stroke: "#E1E4EA"
  })), _rect87 || (_rect87 = /*#__PURE__*/React.createElement("rect", {
    x: 98.5,
    y: 146.709,
    width: 23,
    height: 23,
    stroke: "#E1E4EA"
  })), _rect88 || (_rect88 = /*#__PURE__*/React.createElement("rect", {
    x: 121.5,
    y: 146.709,
    width: 23,
    height: 23,
    stroke: "#E1E4EA"
  })), _rect89 || (_rect89 = /*#__PURE__*/React.createElement("rect", {
    x: 144.5,
    y: 146.709,
    width: 23,
    height: 23,
    stroke: "#E1E4EA"
  })), _rect90 || (_rect90 = /*#__PURE__*/React.createElement("rect", {
    x: 167.5,
    y: 146.709,
    width: 23,
    height: 23,
    stroke: "#E1E4EA"
  })), _rect91 || (_rect91 = /*#__PURE__*/React.createElement("rect", {
    x: 190.5,
    y: 146.709,
    width: 23,
    height: 23,
    stroke: "#E1E4EA"
  })), _rect92 || (_rect92 = /*#__PURE__*/React.createElement("rect", {
    x: 213.5,
    y: 146.709,
    width: 23,
    height: 23,
    stroke: "#E1E4EA"
  })), _rect93 || (_rect93 = /*#__PURE__*/React.createElement("rect", {
    x: 236.5,
    y: 146.709,
    width: 23,
    height: 23,
    stroke: "#E1E4EA"
  })), _rect94 || (_rect94 = /*#__PURE__*/React.createElement("rect", {
    x: 259.5,
    y: 146.709,
    width: 23,
    height: 23,
    stroke: "#E1E4EA"
  })), _rect95 || (_rect95 = /*#__PURE__*/React.createElement("rect", {
    x: 282.5,
    y: 146.709,
    width: 23,
    height: 23,
    stroke: "#E1E4EA"
  })), _rect96 || (_rect96 = /*#__PURE__*/React.createElement("rect", {
    x: 305.5,
    y: 146.709,
    width: 23,
    height: 23,
    stroke: "#E1E4EA"
  })), _rect97 || (_rect97 = /*#__PURE__*/React.createElement("rect", {
    width: 331,
    height: 171,
    transform: "translate(3 5)",
    fill: "url(#paint0_radial_5288_56836)"
  })), _rect98 || (_rect98 = /*#__PURE__*/React.createElement("rect", {
    width: 331,
    height: 171,
    transform: "translate(3 5)",
    fill: "url(#paint1_linear_5288_56836)"
  })), _rect99 || (_rect99 = /*#__PURE__*/React.createElement("rect", {
    x: 56,
    y: 75,
    width: 223,
    height: 57,
    rx: 12,
    fill: "#E6EDFD"
  })), _rect100 || (_rect100 = /*#__PURE__*/React.createElement("rect", {
    x: 39,
    y: 62,
    width: 255,
    height: 62,
    rx: 12,
    fill: "#C2D5FF"
  })), _rect101 || (_rect101 = /*#__PURE__*/React.createElement("rect", {
    x: 28.5,
    y: 46.291,
    width: 277,
    height: 66,
    rx: 11.5,
    fill: "#3F7CDB"
  })), _rect102 || (_rect102 = /*#__PURE__*/React.createElement("rect", {
    x: 28.5,
    y: 46.291,
    width: 277,
    height: 66,
    rx: 11.5,
    stroke: "#3F7CDB"
  })), _rect103 || (_rect103 = /*#__PURE__*/React.createElement("rect", {
    x: 252.5,
    y: 59,
    width: 41,
    height: 41,
    rx: 20.5,
    stroke: "#E1E4EA",
    strokeDasharray: "5 5"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M272.045 85.125V73.875H273.955V85.125H272.045ZM267.375 80.4545V78.5455H278.625V80.4545H267.375Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M40.672 64.5V58.9H42.736C43.96 58.9 44.72 59.396 44.72 60.324C44.72 60.996 44.336 61.428 43.832 61.612C44.456 61.804 44.84 62.196 44.84 62.972C44.84 64.124 43.928 64.5 42.776 64.5H40.672ZM41.584 63.74H42.912C43.528 63.74 43.936 63.508 43.936 62.868C43.936 62.228 43.528 61.988 42.912 61.988H41.584V63.74ZM41.584 61.292H42.856C43.408 61.292 43.816 61.06 43.816 60.468C43.816 59.868 43.408 59.644 42.856 59.644H41.584V61.292ZM46.9706 64.612C46.1226 64.612 45.5706 64.132 45.5706 63.348C45.5706 62.508 46.2026 61.956 47.4746 61.956C47.8906 61.956 48.1866 62.012 48.4026 62.108V61.86C48.4026 61.132 48.0746 60.844 47.4746 60.844C46.9386 60.844 46.5786 61.06 46.4986 61.652L45.6586 61.58C45.7866 60.764 46.3226 60.188 47.4906 60.188C48.6666 60.188 49.2426 60.764 49.2506 61.948V64.5H48.4026V63.636C48.2026 64.3 47.6506 64.612 46.9706 64.612ZM46.4586 63.292C46.4586 63.708 46.7466 63.94 47.2186 63.94C47.9306 63.94 48.4186 63.404 48.4026 62.484H47.7626C46.8186 62.484 46.4586 62.828 46.4586 63.292ZM52.1024 64.58C51.1504 64.58 50.6864 64.188 50.6864 63.156V60.956H49.8224V60.3H50.6864V59.548L51.5424 59.188V60.3H52.9664V60.956H51.5424V63.044C51.5424 63.7 51.7744 63.892 52.3184 63.892C52.5264 63.892 52.7264 63.86 52.9504 63.812V64.484C52.6304 64.548 52.3584 64.58 52.1024 64.58ZM55.4945 64.612C54.1665 64.612 53.3905 63.748 53.3905 62.396C53.3905 61.036 54.1905 60.188 55.4945 60.188C56.5105 60.188 57.2945 60.7 57.4625 61.756L56.6145 61.828C56.5025 61.236 56.1425 60.86 55.5105 60.86C54.7585 60.86 54.3025 61.388 54.3025 62.396C54.3025 63.412 54.7425 63.932 55.5105 63.932C56.1425 63.932 56.5505 63.58 56.6145 62.884L57.4625 62.956C57.3025 64.068 56.5585 64.612 55.4945 64.612ZM58.3106 64.5V58.9H59.1746V61.036C59.3746 60.5 59.9106 60.188 60.5666 60.188C61.4706 60.188 62.0386 60.764 62.0386 61.828V64.5H61.1666V61.988C61.1666 61.228 60.8466 60.852 60.2386 60.852C59.5986 60.852 59.1746 61.26 59.1746 61.988V64.5H58.3106ZM66.5722 64.612C65.7002 64.612 65.0202 64.092 65.0202 62.884V60.3H65.8922V62.684C65.8922 63.628 66.2682 63.94 66.8282 63.94C67.4922 63.94 67.8922 63.508 67.8922 62.66V60.3H68.7562V64.5H67.8922V63.716C67.7242 64.268 67.2842 64.612 66.5722 64.612ZM69.9278 66.02V60.3H70.7758V61.012C71.0398 60.492 71.5838 60.188 72.2398 60.188C73.3518 60.188 74.0558 61.068 74.0558 62.404C74.0558 63.708 73.3837 64.612 72.2398 64.612C71.5758 64.612 71.0798 64.324 70.7838 63.804V66.02H69.9278ZM70.7678 62.404C70.7678 63.428 71.2958 63.924 71.9678 63.924C72.6398 63.924 73.1678 63.428 73.1678 62.404C73.1678 61.372 72.6398 60.868 71.9678 60.868C71.2958 60.868 70.7678 61.372 70.7678 62.404ZM74.9668 58.9H75.8388V64.5H74.9668V58.9ZM78.9181 64.612C77.5501 64.612 76.7341 63.716 76.7341 62.404C76.7341 61.084 77.5501 60.188 78.9181 60.188C80.2861 60.188 81.1021 61.076 81.1021 62.404C81.1021 63.724 80.2861 64.612 78.9181 64.612ZM77.6461 62.404C77.6461 63.412 78.1341 63.94 78.9181 63.94C79.7021 63.94 80.1901 63.412 80.1901 62.404C80.1901 61.388 79.7021 60.86 78.9181 60.86C78.1341 60.86 77.6461 61.388 77.6461 62.404ZM83.1659 64.612C82.3179 64.612 81.7659 64.132 81.7659 63.348C81.7659 62.508 82.3979 61.956 83.6699 61.956C84.0859 61.956 84.3819 62.012 84.5979 62.108V61.86C84.5979 61.132 84.2699 60.844 83.6699 60.844C83.1339 60.844 82.7739 61.06 82.6939 61.652L81.8539 61.58C81.9819 60.764 82.5179 60.188 83.6859 60.188C84.8619 60.188 85.4379 60.764 85.4459 61.948V64.5H84.5979V63.636C84.3979 64.3 83.8459 64.612 83.1659 64.612ZM82.6539 63.292C82.6539 63.708 82.9419 63.94 83.4139 63.94C84.1259 63.94 84.6139 63.404 84.5979 62.484H83.9579C83.0139 62.484 82.6539 62.828 82.6539 63.292ZM88.1846 64.612C87.0566 64.612 86.3046 63.716 86.3046 62.396C86.3046 61.052 87.0886 60.188 88.1846 60.188C88.8566 60.188 89.3446 60.516 89.5686 61.028V58.9H90.4166V64.5H89.5686V63.732C89.3606 64.284 88.8646 64.612 88.1846 64.612ZM87.2006 62.396C87.2006 63.444 87.7366 63.916 88.4006 63.916C89.0566 63.916 89.5926 63.444 89.5926 62.396C89.5926 61.34 89.0566 60.868 88.4006 60.868C87.7366 60.868 87.2006 61.34 87.2006 62.396ZM93.44 64.612C92.112 64.612 91.328 63.708 91.328 62.38C91.328 61.028 92.16 60.188 93.392 60.188C94.752 60.188 95.496 61.18 95.408 62.564H92.2C92.208 63.308 92.576 63.94 93.448 63.94C94.024 63.94 94.424 63.66 94.584 63.06L95.368 63.196C95.192 63.98 94.552 64.612 93.44 64.612ZM92.2 61.98H94.528C94.52 61.46 94.184 60.852 93.392 60.852C92.624 60.852 92.232 61.428 92.2 61.98ZM97.9424 64.612C96.8144 64.612 96.0624 63.716 96.0624 62.396C96.0624 61.052 96.8464 60.188 97.9424 60.188C98.6144 60.188 99.1024 60.516 99.3264 61.028V58.9H100.174V64.5H99.3264V63.732C99.1184 64.284 98.6224 64.612 97.9424 64.612ZM96.9584 62.396C96.9584 63.444 97.4944 63.916 98.1584 63.916C98.8144 63.916 99.3504 63.444 99.3504 62.396C99.3504 61.34 98.8144 60.868 98.1584 60.868C97.4944 60.868 96.9584 61.34 96.9584 62.396Z",
    fill: "white"
  })), _rect104 || (_rect104 = /*#__PURE__*/React.createElement("rect", {
    x: 39.5,
    y: 71,
    width: 33,
    height: 33,
    rx: 16.5,
    fill: "#E6EDFD"
  })), _rect105 || (_rect105 = /*#__PURE__*/React.createElement("rect", {
    x: 39.5,
    y: 71,
    width: 33,
    height: 33,
    rx: 16.5,
    stroke: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M48.6213 83.1H53.9973V84.228H50.0133V86.34H53.7693V87.456H50.0133V91.5H48.6213V83.1ZM58.9484 91.668C56.3924 91.668 54.8684 89.892 54.8684 87.3C54.8684 84.732 56.3564 82.932 58.9724 82.932C61.0484 82.932 62.3444 84.048 62.7284 85.764L61.3604 85.944C61.0484 84.672 60.1964 84.096 58.9964 84.096C57.4124 84.096 56.3324 85.116 56.3324 87.3C56.3324 89.532 57.4844 90.492 58.9844 90.492C60.3044 90.492 61.3724 89.736 61.4684 88.14H58.2524V87.072H62.8604V87.348C62.8604 90.06 61.3964 91.668 58.9484 91.668Z",
    fill: "#597ABF"
  })), _rect106 || (_rect106 = /*#__PURE__*/React.createElement("rect", {
    x: 65.5,
    y: 71,
    width: 33,
    height: 33,
    rx: 16.5,
    fill: "#FBDFC6"
  })), _rect107 || (_rect107 = /*#__PURE__*/React.createElement("rect", {
    x: 65.5,
    y: 71,
    width: 33,
    height: 33,
    rx: 16.5,
    stroke: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M80.661 91.5L76.953 87.36V91.5H75.549V83.1H76.953V87L80.745 83.1H82.329L78.477 87.096L82.425 91.5H80.661ZM83.424 91.5V83.1H88.788V84.216H84.816V86.58H88.548V87.648H84.816V90.36H88.788V91.5H83.424Z",
    fill: "#DE7D54"
  })), _rect108 || (_rect108 = /*#__PURE__*/React.createElement("rect", {
    x: 91.5,
    y: 71,
    width: 33,
    height: 33,
    rx: 16.5,
    fill: "#F6FFF4"
  })), _rect109 || (_rect109 = /*#__PURE__*/React.createElement("rect", {
    x: 91.5,
    y: 71,
    width: 33,
    height: 33,
    rx: 16.5,
    stroke: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M101.649 83.1H103.053V90.372H106.293V91.5H101.649V83.1ZM110.745 91.668C108.261 91.668 106.665 89.916 106.665 87.3C106.665 84.672 108.261 82.932 110.745 82.932C113.217 82.932 114.825 84.672 114.825 87.3C114.825 89.916 113.217 91.668 110.745 91.668ZM108.129 87.3C108.129 89.388 109.185 90.492 110.745 90.492C112.293 90.492 113.361 89.388 113.361 87.3C113.361 85.2 112.293 84.096 110.745 84.096C109.185 84.096 108.129 85.2 108.129 87.3Z",
    fill: "#3FB12C"
  })), _rect110 || (_rect110 = /*#__PURE__*/React.createElement("rect", {
    x: 117.5,
    y: 71,
    width: 33,
    height: 33,
    rx: 16.5,
    fill: "white"
  })), _rect111 || (_rect111 = /*#__PURE__*/React.createElement("rect", {
    x: 117.5,
    y: 71,
    width: 33,
    height: 33,
    rx: 16.5,
    stroke: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M129.657 84.012H130.833V86.616H133.401V87.696H130.833V90.312H129.657V87.696H127.089V86.616H129.657V84.012ZM137.419 91.668C135.703 91.668 134.695 90.732 134.491 89.172L135.811 89.052C135.967 90.144 136.567 90.576 137.431 90.576C138.763 90.576 139.279 89.544 139.351 87.36C138.955 88.008 138.283 88.476 137.215 88.476C135.535 88.476 134.371 87.42 134.371 85.764C134.371 84.06 135.607 82.932 137.491 82.932C139.675 82.932 140.671 84.42 140.671 87.204C140.671 90.24 139.543 91.668 137.419 91.668ZM135.751 85.728C135.751 86.82 136.435 87.468 137.491 87.468C138.535 87.468 139.183 86.82 139.183 85.728C139.183 84.636 138.535 84 137.491 84C136.435 84 135.751 84.636 135.751 85.728Z",
    fill: "#4F555F"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M29.7216 25.2727L32.1506 32.3807H32.2486L34.6776 25.2727H36.1009L32.9602 34H31.4389L28.2983 25.2727H29.7216ZM37.2589 34V27.4545H38.533V34H37.2589ZM37.9023 26.4446C37.6808 26.4446 37.4904 26.3707 37.3313 26.223C37.1751 26.0724 37.0969 25.8935 37.0969 25.6861C37.0969 25.4759 37.1751 25.2969 37.3313 25.1491C37.4904 24.9986 37.6808 24.9233 37.9023 24.9233C38.1239 24.9233 38.3129 24.9986 38.4691 25.1491C38.6282 25.2969 38.7077 25.4759 38.7077 25.6861C38.7077 25.8935 38.6282 26.0724 38.4691 26.223C38.3129 26.3707 38.1239 26.4446 37.9023 26.4446ZM43.0682 34.1321C42.4233 34.1321 41.8679 33.9943 41.402 33.7188C40.9389 33.4403 40.581 33.0497 40.3281 32.5469C40.0781 32.0412 39.9531 31.4489 39.9531 30.7699C39.9531 30.0994 40.0781 29.5085 40.3281 28.9972C40.581 28.4858 40.9332 28.0866 41.3849 27.7997C41.8395 27.5128 42.3707 27.3693 42.9787 27.3693C43.348 27.3693 43.706 27.4304 44.0526 27.5526C44.3991 27.6747 44.7102 27.8665 44.9858 28.1278C45.2614 28.3892 45.4787 28.7287 45.6378 29.1463C45.7969 29.5611 45.8764 30.0653 45.8764 30.6591V31.1108H40.6733V30.1562H44.6278C44.6278 29.821 44.5597 29.5241 44.4233 29.2656C44.2869 29.0043 44.0952 28.7983 43.848 28.6477C43.6037 28.4972 43.3168 28.4219 42.9872 28.4219C42.6293 28.4219 42.3168 28.5099 42.0497 28.6861C41.7855 28.8594 41.581 29.0866 41.4361 29.3679C41.294 29.6463 41.223 29.9489 41.223 30.2756V31.0213C41.223 31.4588 41.2997 31.831 41.4531 32.1378C41.6094 32.4446 41.8267 32.679 42.1051 32.8409C42.3835 33 42.7088 33.0795 43.081 33.0795C43.3224 33.0795 43.5426 33.0455 43.7415 32.9773C43.9403 32.9062 44.1122 32.8011 44.2571 32.6619C44.402 32.5227 44.5128 32.3509 44.5895 32.1463L45.7955 32.3636C45.6989 32.7187 45.5256 33.0298 45.2756 33.2969C45.0284 33.5611 44.7173 33.767 44.3423 33.9148C43.9702 34.0597 43.5455 34.1321 43.0682 34.1321ZM48.6974 34L46.7713 27.4545H48.0881L49.3707 32.2614H49.4347L50.7216 27.4545H52.0384L53.3168 32.2401H53.3807L54.6548 27.4545H55.9716L54.0497 34H52.75L51.4205 29.2741H51.3224L49.9929 34H48.6974ZM60.3565 34V27.4545H61.6307V34H60.3565ZM61 26.4446C60.7784 26.4446 60.5881 26.3707 60.429 26.223C60.2727 26.0724 60.1946 25.8935 60.1946 25.6861C60.1946 25.4759 60.2727 25.2969 60.429 25.1491C60.5881 24.9986 60.7784 24.9233 61 24.9233C61.2216 24.9233 61.4105 24.9986 61.5668 25.1491C61.7259 25.2969 61.8054 25.4759 61.8054 25.6861C61.8054 25.8935 61.7259 26.0724 61.5668 26.223C61.4105 26.3707 61.2216 26.4446 61 26.4446ZM64.619 30.1136V34H63.3448V27.4545H64.5678V28.5199H64.6488C64.7994 28.1733 65.0352 27.8949 65.3562 27.6847C65.68 27.4744 66.0877 27.3693 66.5792 27.3693C67.0252 27.3693 67.4158 27.4631 67.7511 27.6506C68.0863 27.8352 68.3462 28.1108 68.5309 28.4773C68.7156 28.8437 68.8079 29.2969 68.8079 29.8366V34H67.5337V29.9901C67.5337 29.5156 67.4102 29.1449 67.163 28.8778C66.9158 28.608 66.5763 28.473 66.1445 28.473C65.8491 28.473 65.5863 28.5369 65.3562 28.6648C65.1289 28.7926 64.9485 28.9801 64.815 29.2273C64.6843 29.4716 64.619 29.767 64.619 30.1136ZM73.6317 27.4545V28.4773H69.9329V27.4545H73.6317ZM70.9471 34V26.696C70.9471 26.2869 71.0366 25.9474 71.2156 25.6776C71.3945 25.4048 71.6317 25.2017 71.9272 25.0682C72.2227 24.9318 72.5437 24.8636 72.8903 24.8636C73.146 24.8636 73.3647 24.8849 73.5465 24.9276C73.7283 24.9673 73.8633 25.0043 73.9513 25.0384L73.6531 26.0696C73.5934 26.0526 73.5167 26.0327 73.4229 26.0099C73.3292 25.9844 73.2156 25.9716 73.082 25.9716C72.7724 25.9716 72.5508 26.0483 72.4173 26.2017C72.2866 26.3551 72.2212 26.5767 72.2212 26.8665V34H70.9471ZM77.4457 34.1321C76.832 34.1321 76.2965 33.9915 75.8391 33.7102C75.3817 33.429 75.0266 33.0355 74.7738 32.5298C74.521 32.0241 74.3945 31.4332 74.3945 30.7571C74.3945 30.0781 74.521 29.4844 74.7738 28.9759C75.0266 28.4673 75.3817 28.0724 75.8391 27.7912C76.2965 27.5099 76.832 27.3693 77.4457 27.3693C78.0593 27.3693 78.5948 27.5099 79.0522 27.7912C79.5096 28.0724 79.8647 28.4673 80.1175 28.9759C80.3704 29.4844 80.4968 30.0781 80.4968 30.7571C80.4968 31.4332 80.3704 32.0241 80.1175 32.5298C79.8647 33.0355 79.5096 33.429 79.0522 33.7102C78.5948 33.9915 78.0593 34.1321 77.4457 34.1321ZM77.4499 33.0625C77.8477 33.0625 78.1772 32.9574 78.4386 32.7472C78.6999 32.5369 78.8931 32.2571 79.0181 31.9077C79.146 31.5582 79.2099 31.1733 79.2099 30.7528C79.2099 30.3352 79.146 29.9517 79.0181 29.6023C78.8931 29.25 78.6999 28.9673 78.4386 28.7543C78.1772 28.5412 77.8477 28.4347 77.4499 28.4347C77.0494 28.4347 76.717 28.5412 76.4528 28.7543C76.1914 28.9673 75.9968 29.25 75.869 29.6023C75.744 29.9517 75.6815 30.3352 75.6815 30.7528C75.6815 31.1733 75.744 31.5582 75.869 31.9077C75.9968 32.2571 76.1914 32.5369 76.4528 32.7472C76.717 32.9574 77.0494 33.0625 77.4499 33.0625ZM81.919 34V27.4545H83.1506V28.4943H83.2188C83.3381 28.142 83.5483 27.8651 83.8494 27.6634C84.1534 27.4588 84.4972 27.3565 84.8807 27.3565C84.9602 27.3565 85.054 27.3594 85.1619 27.3651C85.2727 27.3707 85.3594 27.3778 85.4219 27.3864V28.6051C85.3707 28.5909 85.2798 28.5753 85.1491 28.5582C85.0185 28.5384 84.8878 28.5284 84.7571 28.5284C84.456 28.5284 84.1875 28.5923 83.9517 28.7202C83.7188 28.8452 83.5341 29.0199 83.3977 29.2443C83.2614 29.4659 83.1932 29.7187 83.1932 30.0028V34H81.919ZM86.5245 34V27.4545H87.7475V28.5199H87.8285C87.9648 28.1591 88.1879 27.8778 88.4975 27.6761C88.8072 27.4716 89.1779 27.3693 89.6097 27.3693C90.0472 27.3693 90.4137 27.4716 90.7092 27.6761C91.0075 27.8807 91.2276 28.1619 91.3697 28.5199H91.4379C91.5941 28.1705 91.8427 27.892 92.1836 27.6847C92.5245 27.4744 92.9308 27.3693 93.4023 27.3693C93.9961 27.3693 94.4805 27.5554 94.8555 27.9276C95.2333 28.2997 95.4222 28.8608 95.4222 29.6108V34H94.1481V29.7301C94.1481 29.2869 94.0273 28.9659 93.7859 28.767C93.5444 28.5682 93.256 28.4688 92.9208 28.4688C92.506 28.4688 92.1836 28.5966 91.9535 28.8523C91.7234 29.1051 91.6083 29.4304 91.6083 29.8281V34H90.3384V29.6491C90.3384 29.294 90.2276 29.0085 90.006 28.7926C89.7844 28.5767 89.4961 28.4688 89.141 28.4688C88.8995 28.4688 88.6765 28.5327 88.4719 28.6605C88.2702 28.7855 88.1069 28.9602 87.9819 29.1847C87.8597 29.4091 87.7987 29.669 87.7987 29.9645V34H86.5245ZM99.0348 34.1449C98.62 34.1449 98.245 34.0682 97.9098 33.9148C97.5746 33.7585 97.3089 33.5327 97.1129 33.2372C96.9197 32.9418 96.8232 32.5795 96.8232 32.1506C96.8232 31.7812 96.8942 31.4773 97.0362 31.2386C97.1783 31 97.37 30.8111 97.6115 30.6719C97.853 30.5327 98.1229 30.4276 98.4212 30.3565C98.7195 30.2855 99.0234 30.2315 99.3331 30.1946C99.7251 30.1491 100.043 30.1122 100.288 30.0838C100.532 30.0526 100.71 30.0028 100.82 29.9347C100.931 29.8665 100.987 29.7557 100.987 29.6023V29.5724C100.987 29.2003 100.881 28.9119 100.671 28.7074C100.464 28.5028 100.154 28.4006 99.7422 28.4006C99.3132 28.4006 98.9751 28.4957 98.728 28.6861C98.4837 28.8736 98.3146 29.0824 98.2209 29.3125L97.0234 29.0398C97.1655 28.642 97.3729 28.321 97.6456 28.0767C97.9212 27.8295 98.2379 27.6506 98.5959 27.5398C98.9538 27.4261 99.3303 27.3693 99.7251 27.3693C99.9865 27.3693 100.263 27.4006 100.556 27.4631C100.852 27.5227 101.127 27.6335 101.383 27.7955C101.641 27.9574 101.853 28.1889 102.018 28.4901C102.183 28.7884 102.265 29.1761 102.265 29.6534V34H101.021V33.1051H100.969C100.887 33.2699 100.763 33.4318 100.599 33.5909C100.434 33.75 100.222 33.8821 99.9638 33.9872C99.7053 34.0923 99.3956 34.1449 99.0348 34.1449ZM99.3118 33.1222C99.6641 33.1222 99.9652 33.0526 100.215 32.9134C100.468 32.7741 100.66 32.5923 100.79 32.3679C100.924 32.1406 100.991 31.8977 100.991 31.6392V30.7955C100.945 30.8409 100.857 30.8835 100.727 30.9233C100.599 30.9602 100.452 30.9929 100.288 31.0213C100.123 31.0469 99.9624 31.071 99.8061 31.0938C99.6499 31.1136 99.5192 31.1307 99.4141 31.1449C99.1669 31.1761 98.9411 31.2287 98.7365 31.3026C98.5348 31.3764 98.3729 31.483 98.2507 31.6222C98.1314 31.7585 98.0717 31.9403 98.0717 32.1676C98.0717 32.483 98.1882 32.7216 98.4212 32.8835C98.6541 33.0426 98.951 33.1222 99.3118 33.1222ZM107.017 27.4545V28.4773H103.442V27.4545H107.017ZM104.401 25.8864H105.675V32.0781C105.675 32.3253 105.712 32.5114 105.786 32.6364C105.86 32.7585 105.955 32.8423 106.071 32.8878C106.191 32.9304 106.32 32.9517 106.459 32.9517C106.561 32.9517 106.651 32.9446 106.728 32.9304C106.804 32.9162 106.864 32.9048 106.907 32.8963L107.137 33.9489C107.063 33.9773 106.958 34.0057 106.821 34.0341C106.685 34.0653 106.515 34.0824 106.31 34.0852C105.975 34.0909 105.662 34.0312 105.373 33.9062C105.083 33.7812 104.848 33.5881 104.669 33.3267C104.49 33.0653 104.401 32.7372 104.401 32.3423V25.8864ZM108.427 34V27.4545H109.701V34H108.427ZM109.07 26.4446C108.849 26.4446 108.658 26.3707 108.499 26.223C108.343 26.0724 108.265 25.8935 108.265 25.6861C108.265 25.4759 108.343 25.2969 108.499 25.1491C108.658 24.9986 108.849 24.9233 109.07 24.9233C109.292 24.9233 109.481 24.9986 109.637 25.1491C109.796 25.2969 109.876 25.4759 109.876 25.6861C109.876 25.8935 109.796 26.0724 109.637 26.223C109.481 26.3707 109.292 26.4446 109.07 26.4446ZM114.172 34.1321C113.559 34.1321 113.023 33.9915 112.566 33.7102C112.108 33.429 111.753 33.0355 111.5 32.5298C111.248 32.0241 111.121 31.4332 111.121 30.7571C111.121 30.0781 111.248 29.4844 111.5 28.9759C111.753 28.4673 112.108 28.0724 112.566 27.7912C113.023 27.5099 113.559 27.3693 114.172 27.3693C114.786 27.3693 115.321 27.5099 115.779 27.7912C116.236 28.0724 116.591 28.4673 116.844 28.9759C117.097 29.4844 117.223 30.0781 117.223 30.7571C117.223 31.4332 117.097 32.0241 116.844 32.5298C116.591 33.0355 116.236 33.429 115.779 33.7102C115.321 33.9915 114.786 34.1321 114.172 34.1321ZM114.176 33.0625C114.574 33.0625 114.904 32.9574 115.165 32.7472C115.426 32.5369 115.62 32.2571 115.745 31.9077C115.873 31.5582 115.936 31.1733 115.936 30.7528C115.936 30.3352 115.873 29.9517 115.745 29.6023C115.62 29.25 115.426 28.9673 115.165 28.7543C114.904 28.5412 114.574 28.4347 114.176 28.4347C113.776 28.4347 113.444 28.5412 113.179 28.7543C112.918 28.9673 112.723 29.25 112.596 29.6023C112.471 29.9517 112.408 30.3352 112.408 30.7528C112.408 31.1733 112.471 31.5582 112.596 31.9077C112.723 32.2571 112.918 32.5369 113.179 32.7472C113.444 32.9574 113.776 33.0625 114.176 33.0625ZM119.92 30.1136V34H118.646V27.4545H119.869V28.5199H119.95C120.1 28.1733 120.336 27.8949 120.657 27.6847C120.981 27.4744 121.388 27.3693 121.88 27.3693C122.326 27.3693 122.717 27.4631 123.052 27.6506C123.387 27.8352 123.647 28.1108 123.832 28.4773C124.016 28.8437 124.109 29.2969 124.109 29.8366V34H122.835V29.9901C122.835 29.5156 122.711 29.1449 122.464 28.8778C122.217 28.608 121.877 28.473 121.445 28.473C121.15 28.473 120.887 28.5369 120.657 28.6648C120.43 28.7926 120.249 28.9801 120.116 29.2273C119.985 29.4716 119.92 29.767 119.92 30.1136Z",
    fill: "#B7BBC3"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_5288_56836",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(165.5 85.5) rotate(90) scale(159.187 308.134)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_5288_56836",
    x1: 165.5,
    y1: -39.7312,
    x2: 165.5,
    y2: 189.281,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.474771,
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPerformBatchLookup);
export default __webpack_public_path__ + "static/media/perform-batch-lookup.2743c825951a873a2bf77760a7146ebe.svg";
export { ForwardRef as ReactComponent };